import { ListItemButton, ListItemText } from '@mui/material';
import { NavLink } from 'react-router';

type NavItemProps = {
  to: string;
  children: string;
};

export const NavItem = ({ to, children }: NavItemProps) => {
  return (
    <NavLink to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
      {({ isActive }) => (
        <ListItemButton selected={isActive}>
          <ListItemText
            primary={children}
            slotProps={{
              primary: {
                fontWeight: isActive ? 'bold' : 'regular',
              },
            }}
          />
        </ListItemButton>
      )}
    </NavLink>
  );
};
